import { createHook } from '../index.tsx';

export const useGetViewPermissionLockSpotlight = createHook(
	(state) => state.viewPermissions.spotlightDismissed,
);
